import { createEventBus } from '@/event-bus/EventBus'

export default createEventBus()
